import { CheckCircle2, CircleDashed, CircleDot } from 'lucide-react'
import type { Mention } from '@/lib/types'
import { mentionBadgeClasses } from './MentionBadge.styles'

export function MentionBadge({
  label,
  mention,
}: {
  label: string
  mention: Mention
}) {
  // Colors are semantic so the badge tracks the signal: green = brand directly
  // recommended, amber = mentioned indirectly, muted = not mentioned. (The old
  // `direct` used `accent`, a near-white neutral, so positive mentions rendered
  // as invisible gray-on-gray and looked indistinguishable from `none`.)
  const cfg = {
    direct: {
      Icon: CheckCircle2,
    },
    indirect: {
      Icon: CircleDot,
    },
    none: {
      Icon: CircleDashed,
    },
  }[mention]
  const Icon = cfg.Icon

  return (
    <span
      aria-label={label}
      title={label}
      className={`inline-flex shrink-0 items-center gap-1 rounded border px-1.5 py-0.5 text-[10px] uppercase ${mentionBadgeClasses[mention]}`}
    >
      <Icon className="size-2.5" />
      <span data-slot="mention-badge-label">{label}</span>
    </span>
  )
}
